import { m, monthName } from '@/lib/i18n';
import type { Chore } from '@/lib/types';

export const FREQS: [number, () => string][] = [
  [7, () => m.freq_weekly()],
  [14, () => m.freq_2weeks()],
  [30, () => m.freq_monthly()],
  [60, () => m.freq_2months()],
  [91, () => m.freq_3months()],
  [182, () => m.freq_twice_year()],
  [365, () => m.freq_yearly()],
];

export function freqLabel(d: number) {
  const preset = FREQS.find(([n]) => n === d);
  if (preset) return preset[1]();
  if (d === 1) return m.freq_daily();
  return d % 7 === 0 ? m.freq_every_weeks({ count: d / 7 }) : m.freq_every_days({ count: d });
}

export function dueText(c: Chore) {
  if (!c.inSeason) return m.in_season({ months: c.months.map(monthName).join(', ') });
  if (c.ratio > 1) {
    const late = Math.round((c.ratio - 1) * c.freqDays);
    return late <= 0 ? m.due_today() : m.days_overdue({ count: late });
  }
  if (c.dueInDays <= 0) return m.due_today();
  if (c.dueInDays === 1) return m.due_tomorrow();
  return m.due_in_days({ count: c.dueInDays });
}

export function lastDoneText(c: Chore) {
  if (c.daysSince === null) return m.not_done_yet();
  const when = c.daysSince === 0 ? m.last_done_today() : c.daysSince === 1 ? m.last_done_yesterday() : m.last_done_days({ count: c.daysSince });
  return c.lastDoneBy ? m.last_done_by({ when, name: c.lastDoneBy.name }) : when;
}
